import { SelectionSummary } from '.';
import { surveyReportHelper } from '../helpers';

export class SelectionStats
{
    public data:SelectionSummary;
    public totalSelections:number;
    public selectionSum:number;
    public selectionAverage:number;
    public agreePlusPct:number;
    public disagreeMinusPct:number;

    constructor(
        selectionReport:SelectionSummary,
    ){
        this.data = {...selectionReport};

        this.totalSelections = 
            this.data.value1Count +
            this.data.value2Count +
            this.data.value3Count +
            this.data.value4Count +
            this.data.value5Count;
        
        this.selectionSum = 
            this.data.value1Count*1 +
            this.data.value2Count*2 +
            this.data.value3Count*3 +
            this.data.value4Count*4 +
            this.data.value5Count*5;
        
        this.selectionAverage = 
            this.selectionSum / this.totalSelections;
        
        this.agreePlusPct =
            (this.data.value4Count + this.data.value5Count) / this.totalSelections * 100;            

        this.disagreeMinusPct =
            (this.data.value1Count + this.data.value2Count) / this.totalSelections * 100;
    }
    
    static aggregateList(list:SelectionSummary[]):SelectionStats
    {
        if(list.length == 0)
            return new SelectionStats(surveyReportHelper.createNewSelectionSummary());

        let combined = {...list[0]};
        for(let i=1; i<list.length; i++)
            combined = SelectionStats.aggregate(combined, list[i]).data;

        return new SelectionStats(combined);
    }   

    static aggregate(s1:SelectionSummary, s2:SelectionSummary):SelectionStats
    {
        return new SelectionStats({
            value1Count: s1.value1Count + s2.value1Count,
            value2Count: s1.value2Count + s2.value2Count,
            value3Count: s1.value3Count + s2.value3Count,
            value4Count: s1.value4Count + s2.value4Count,
            value5Count: s1.value5Count + s2.value5Count,
        });
    }
}